// store/modules/voiceAI.js
const voiceAIModule = {
    namespaced: true,
    
    state: () => ({
      voiceAIParams: null,
      voiceAIUrl: null,
      voiceAIResult: null
    }),
    
    mutations: {
      SET_VOICE_AI_PARAMS(state, params) {
        state.voiceAIParams = params
      },
      
      SET_VOICE_AI_URL(state, url) {
        state.voiceAIUrl = url
      },
      
      // 也可以用一个 mutation 同时设置两个值
      SET_VOICE_AI_CONFIG(state, { params, url }) {
        state.voiceAIParams = params
        state.voiceAIUrl = url
      },
      
      SET_VOICE_AI_RESULT(state, result) {
        state.voiceAIResult = result
      }
    },
    
    actions: {
      updateVoiceAIConfig({ commit }, config) {
        if (config.params) {
          commit('SET_VOICE_AI_PARAMS', config.params)
        }
        if (config.url) {
          commit('SET_VOICE_AI_URL', config.url)
        }
        if (config.result) {
          commit('SET_VOICE_AI_RESULT', config.result)
        }
      }
    },
    
    getters: {
      hasVoiceAIUrl: state => !!state.voiceAIUrl,
      getVoiceAIConfig: state => ({
        params: state.voiceAIParams,
        url: state.voiceAIUrl,
        result: state.voiceAIResult
      })
    }
  }
  
  export default voiceAIModule